export type VideoOptions = {
  EMS_SERVER_URL: string;
  VIDEO_SERVER_URL: string;
  VIDEO_RECORDINGS_ROOT_URL: string;
};

export function getVideoOptions(): VideoOptions {
  const options = window.videoOptions as VideoOptions | undefined;
  if (!options) {
    throw new Error('window.videoOptions is not set - /video.config.js has not been loaded yet');
  }

  return options;
}
